export default function() {}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/noop.js
// module id = 67xg
// module chunks = 0